// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4051":"2f627e5f","5116":"20c8e13d","5264":"20c8e13d"}[chunkId] + ".chunk.css";
};